import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const Row = styled.div`
  ${tw`relative w-full max-w-def mx-auto`};
`;

export default Row;
